import ErrorHandler from './ErrorHandler';

export default ErrorHandler;


// WEBPACK FOOTER //
// ./src/modules/error-handler/index.js